"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tags = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
require("@oneloop/fonts");
var _icons = require("@oneloop/icons");
var _excluded = ["children", "closeIcon", "variant", "noClick"];
/* eslint-disable no-unused-expressions */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Tags = exports.Tags = function Tags(_ref) {
  var children = _ref.children,
    closeIcon = _ref.closeIcon,
    variant = _ref.variant,
    _ref$noClick = _ref.noClick,
    noClick = _ref$noClick === void 0 ? false : _ref$noClick,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "div",
    tx: "tags",
    variant: variant
  }, props, {
    __css: {
      fontFamily: 'Nunito Sans',
      display: 'inline-flex',
      alignItems: 'center',
      padding: '3px 4px',
      gap: '5px',
      height: '20px',
      borderRadius: '4px',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '12px',
      cursor: !noClick ? 'pointer' : 'default',
      border: 'solid 1px transparent',
      pointerEvents: noClick && 'none'
    }
  }), children, closeIcon && /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-cerrar",
    onClick: function onClick(event) {
      event.stopPropagation();
      closeIcon();
    },
    fontSize: "8px",
    style: {
      cursor: 'pointer'
    }
  }));
};